import { CurriculumType, ExportType, CMContentType } from "@/util/enum";
import { ITreeNode } from "@/services/objective-manager";
import { store } from "@/commonui/store/index";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import { UnitListManagerService, IUnitListManager } from "@/services/text-guardian/unit-list";
import { UnitRangeModel } from "@/services/objective-manager";
import { VersionGroupModel } from "@/services/version-group";
import { ObjectiveService } from "@/services/objective-manager";
import { ContentExposureService } from "@/services/content-exposure";
import { MethodologyType } from "@/util/enum";
import { VersionGroupModule } from "./versiongroup";
import {
	LessonPlanVersionService,
	ILessonPlanVersionService,
	ILessonPlanListService,
	LessonPlanListService
} from "@/services/lesson-plan";
import { ILessonPlanVersionModel, sortLessonPlanVersions } from "@/models/lesson-plan";
import { ResourceService, ContentSimpleModel, ContentExposureContent } from "@/services/resource";
import { BlobHelper } from "@/util/helper";
import { MethodologyTypeItems } from "@/util/constants";
import { TitleListService } from "@/services/title-list-service";
import { VCSLevelModel } from "@/models/title-list-model";
import { deepClone } from "@/util/func";
import { cloneDeep } from "lodash";
function toTimeString(second) {
	const sec = second % 60;
	return `${Math.floor(second / 60)}:${sec > 9 ? sec : `0${sec}`}`;
}
@Module({ namespaced: true, name: "ReportsObjectiveState", store: store, dynamic: true })
class ReportsObjectiveState extends VuexModule {
	unitListManager: IUnitListManager = UnitListManagerService();
	lessonPlanListService: ILessonPlanListService = LessonPlanListService();
	lessonPlanVersionService: ILessonPlanVersionService = LessonPlanVersionService();
	versionGroupModule = VersionGroupModule;
	vcsUnits: VCSLevelModel[] = [];
	versionGroup = {} as VersionGroupModel;
	isShowObjective = false;
	isShowObjectiveNumber = false;
	level3 = 3;
	methodologyType: MethodologyType = MethodologyType.Classic;
	contentId: string = "";
	contents: ContentExposureContent[] = [];
	contentExposures: any[] = [];
	selectedUnit: VCSLevelModel = {} as VCSLevelModel;
	unitObject: UnitRangeModel = {} as UnitRangeModel;
	lessonplanVersions: ILessonPlanVersionModel[] = [];
	versionId: string = "";
	isLoading: boolean = false;
	vpcs: ContentSimpleModel[] = [];
	lessonPlanSimples: any[] = [];
	relatedVpcCounts: any[] = [];
	formatedVpcs: any[] = [];
	vpcsTwoDimension: any[] = [];
	objectivesTree: ITreeNode[] = [];
	firstObjectives: ITreeNode[] = [];
	phonogramCards = {} as any;
	reviewVpcs: any[] = [];
	isLevel4Checked: boolean = false;
	showLevel4Column: boolean = false;
	componentObjectiveReportData = [];
	componentObjectiveGridLoading: boolean = false;
	focusWordChapterReportData = [];
	masteryQuestionObjectiveReportData = [];
	mediaChangeImpactReportData = [];
	mediaChangeImpactReportGridLoading: boolean = false;
	selectedContentIdForReport: string | null = null;
	selectedObjectiveIdForReport: string | null = null;
	unitRangeForReport: UnitRangeModel = {} as UnitRangeModel;

	@Mutation
	setVCSLevelUnits(units: VCSLevelModel[]) {
		this.vcsUnits = units;
	}

	@Mutation
	setVersionGroup(value: VersionGroupModel) {
		this.versionGroup = value;
	}

	@Mutation
	setLoading(isLoading: boolean) {
		this.isLoading = isLoading;
	}

	@Mutation
	setSelectedUnits(units) {
		this.unitObject = units;
	}

	@Mutation
	setIsLevel4Checked(value: boolean) {
		this.isLevel4Checked = value;
	}

	@Mutation
	setShowLevel4Column(value: boolean) {
		this.showLevel4Column = value;
	}

	@Mutation
	setComponentObjectiveReportData(value) {
		this.componentObjectiveReportData = cloneDeep(value);
	}

	@Mutation
	setFocusWordChapterReportData(value) {
		this.focusWordChapterReportData = cloneDeep(value);
	}

	@Mutation
	setComponentObjectiveGridLoading(value) {
		this.componentObjectiveGridLoading = value;
	}

	@Mutation
	setMasteryQuestionObjectiveReportData(value) {
		this.masteryQuestionObjectiveReportData = cloneDeep(value);
	}

	@Mutation
	setMediaChangeImpactReportData(value) {
		this.mediaChangeImpactReportData = value;
	}

	@Mutation
	setMediaChangeImpactReportGridLoading(value) {
		this.mediaChangeImpactReportGridLoading = value;
	}

	@Mutation
	setShowObjectiveDetail(isShow) {
		this.isShowObjective = isShow;
	}

	@Mutation
	setShowObjectiveNumber(isShow) {
		this.isShowObjectiveNumber = isShow;
	}

	@Mutation
	setSelectedUnit(value) {
		this.selectedUnit = value;
	}

	@Mutation
	setMethodologyType(value) {
		this.methodologyType = value;
	}

	@Mutation
	setContentId(value) {
		this.contentId = value;
	}

	@Mutation
	setContents(contents: any) {
		this.contents = contents;
	}

	@Mutation
	setContentExposures(exposures) {
		this.contentExposures = exposures;
	}

	@Mutation
	setLessonplanVersions(versions) {
		this.lessonplanVersions = versions;
	}

	@Mutation
	setLessonplanVersionId(versionId) {
		this.versionId = versionId;
	}

	@Mutation
	setVpcs(vpcs) {
		this.vpcs = vpcs;
	}

	@Mutation
	setVpcsTwoDimension(array) {
		this.vpcsTwoDimension = array;
	}

	@Mutation
	setReviewVpcs(reviewVpcs) {
		this.reviewVpcs = reviewVpcs;
	}

	@Mutation
	setLessonplanSimples(simples) {
		this.lessonPlanSimples = simples;
	}

	@Mutation
	setRelatedVpcCounts(counts) {
		this.relatedVpcCounts = counts;
	}

	@Mutation
	setFormatedVpcs(vpcs) {
		this.formatedVpcs = vpcs;
	}

	@Mutation
	setPhonogramCards(cards) {
		this.phonogramCards = cards;
	}

	@Mutation
	setObjectivesTree(tree) {
		this.objectivesTree = tree;
	}

	@Mutation
	setFirstObjectivesTree(tree) {
		this.firstObjectives = tree;
	}

	@Mutation
	setCurrentVersionGroup() {
		const id =
			this.selectedUnit?.curriculumType == CurriculumType.GrapeSEED
				? this.versionGroupModule.selectedGsVersion
				: this.versionGroupModule.selectedLsVersion;
		this.versionGroup = this.versionGroupModule.versionGroups.find((v) => v.id == id)!;
	}

	@Mutation
	setSelectedContentIdForReport(value) {
		this.selectedContentIdForReport = value;
	}

	@Mutation
	setSelectedObjectiveIdForReport(value) {
		this.selectedObjectiveIdForReport = value;
	}

	@Mutation
	setUnitRangeForReport(value) {
		this.unitRangeForReport = value;
	}

	@Action
	async getVCSLevelUnits() {
		const units = await TitleListService.getLevels([], true);
		this.setVCSLevelUnits(units);
	}

	@Action
	async getTitleTextList(methodology) {
		const params = {
			vcsLevelId: this.selectedUnit.id,
			versionGroupId:
				this.selectedUnit.curriculumType == CurriculumType.GrapeSEED
					? this.versionGroupModule.selectedGsVersion
					: this.versionGroupModule.selectedLsVersion,
			methodology: methodology
		};
		await ResourceService.getContentExposureContents(params).then((data) => {
			this.setContents(data);
		});
	}

	@Action
	async getContentExposures(lessonPlanVersionId: string) {
		this.setLoading(true);
		ContentExposureService.getContentExposures({
			contentId: this.contentId,
			lessonPlanVersionId
		}).then((contentExposures) => {
			this.formatContentExposures(contentExposures);
			this.setContentExposures(contentExposures);
			this.setLoading(false);
		});
	}

	@Action
	async getLessonPlanVersions() {
		this.setLoading(true);
		await this.lessonPlanVersionService
			.getLessonPlanVersions(
				[this.versionGroupModule.selectedGsVersion, this.versionGroupModule.selectedLsVersion],
				this.methodologyType
			)
			.then((versions) => {
				const sortedLessonPlanVersions = versions.sort(sortLessonPlanVersions);
				this.setLessonplanVersions(sortedLessonPlanVersions);
				this.setLessonplanVersions(versions);
				this.setLoading(false);
			});
	}

	@Action
	async getVpcs() {
		return await ResourceService.getClassRoomMaterialsContents({
			versionId:
				this.selectedUnit.curriculumType == CurriculumType.GrapeSEED
					? this.versionGroupModule.selectedGsVersion
					: this.versionGroupModule.selectedLsVersion,
			vcsLevelId: this.selectedUnit.id,
			type: CMContentType.VPC
		});
	}

	@Action
	async getLessonPlansSimples() {
		return await this.lessonPlanListService.getLessonPlans(this.versionId, this.selectedUnit.id);
	}

	@Action
	async getRelatedVpcCount() {
		return await this.lessonPlanListService.getRelatedVpcCount(this.versionId, this.selectedUnit.id);
	}

	@Action
	async getLetterphonogramcards() {
		const params = {
			versionId:
				this.selectedUnit.curriculumType == CurriculumType.GrapeSEED
					? this.versionGroupModule.selectedGsVersion
					: this.versionGroupModule.selectedLsVersion,
			vcsLevelId: this.selectedUnit.id
		};
		return await ResourceService.getUnitOverviewPhonograms(params);
	}

	@Action
	async getObjectivesTree() {
		const { id, curriculumType } = this.selectedUnit;
		const params = {
			endUnitId: id,
			startUnitId: id,
			toLeaves: false,
			withDeepest: true,
			mustDeepest: true,
			level: this.level3,
			versionGroupId:
				curriculumType == CurriculumType.GrapeSEED
					? this.versionGroupModule.selectedGsVersion
					: this.versionGroupModule.selectedLsVersion
		};
		return await ObjectiveService.getObjectivesTree(params);
	}

	@Action
	async exportObjective(exportType: ExportType) {
		this.setLoading(true);
		const { id, name } = this.versionGroup;
		const { startUnitId, endUnitId } = this.unitObject;
		const startUnitDisplayName = this.vcsUnits.find((u) => u.id == startUnitId)?.displayName;
		const endUnitDisplayName = this.vcsUnits.find((u) => u.id == endUnitId)?.displayName;
		let objectives = deepClone(this.objectivesTree);

		const curriculumType =
			this.versionGroupModule.selectedGsVersion !== "-1"
				? CurriculumType.GrapeSEED
				: VersionGroupModule.selectedLsVersion !== "-1"
				? CurriculumType.LittleSEED
				: -1;

		const units = this.vcsUnits.filter(
			(u) =>
				u.curriculumType === curriculumType &&
				(u.id === this.unitObject.startUnitId || u.id === this.unitObject.endUnitId)
		);

		const startUnit = units.find((u) => u.id === this.unitObject.startUnitId);
		const endUnit = units.find((u) => u.id === this.unitObject.endUnitId);

		const selectedUnits = this.vcsUnits.filter(
			(u) => u.curriculumType === curriculumType && u.unit >= startUnit?.unit! && u.unit <= endUnit?.unit!
		);

		const selectedUnitIds = selectedUnits.map((u) => u.id);

		if (!this.isShowObjective) {
			const removeLevel4Objective = (arr: ITreeNode[]) => {
				return arr.map((a) => {
					if (a.level <= 2) {
						a.children = removeLevel4Objective(a.children) as any[];
					}
					if (a.level === 3) {
						a.children = [];
					}

					const {
						id,
						parentId,
						level,
						sequence,
						title,
						unitObjective,
						versionGroupId,
						objectiveNumber,
						children
					} = a;

					return {
						id,
						parentId,
						level,
						sequence,
						text: title,
						unitObjective: unitObjective
							.filter((u) => selectedUnitIds.includes(u.unitId))
							.map((u) => ({ ...u, unit: null })),
						contentObjective: [],
						versionGroupId,
						objectiveNumber,
						children
					};
				});
			};

			objectives = removeLevel4Objective(objectives);
		} else {
			const formatObjective = (arr: ITreeNode[]) => {
				return arr.map((a) => {
					if (a.children.length) {
						a.children = formatObjective(a.children) as any[];
					}

					const {
						id,
						parentId,
						level,
						sequence,
						title,
						unitObjective,
						versionGroupId,
						objectiveNumber,
						children
					} = a;

					return {
						id,
						parentId,
						level,
						sequence,
						text: title,
						unitObjective: unitObjective
							.filter((u) => selectedUnitIds.includes(u.unitId))
							.map((u) => ({ ...u, unit: null })),
						contentObjective: [],
						versionGroupId,
						objectiveNumber,
						children
					};
				});
			};

			objectives = formatObjective(objectives);
		}

		const params = {
			versionGroupId: id,
			startUnitId: startUnitId,
			endUnitId: endUnitId,
			showObjectiveNumber: this.isShowObjectiveNumber,
			hasLevel4: this.isShowObjective,
			fileName: `UnitObjectives-${name}-${startUnitDisplayName}-${endUnitDisplayName}`,
			objectives,
			exportType
		};

		await ObjectiveService.exportObjectiveReport(params).then((data) => {
			BlobHelper.saveFile(data);
			this.setLoading(false);
		});
	}

	@Action
	async getUnitOverviewPDF() {
		this.setLoading(true);
		const { id, name } = this.versionGroup;
		const params = {
			endUnitId: this.selectedUnit.id,
			startUnitId: this.selectedUnit.id,
			fileName: `UnitOverview-${name}-${this.selectedUnit.displayName}`,
			versionGroupId: id
		};
		return await this.unitListManager.exportOverViewPDF(params).then((data) => {
			BlobHelper.saveFile(data);
			this.setLoading(false);
		});
	}

	@Action
	async getVpcOverviewPDF() {
		this.setLoading(true);
		const { id, name } = this.versionGroup;
		const versionName = this.lessonplanVersions.find((v) => v.id == this.versionId)?.name;
		const methodologyName = MethodologyTypeItems.get(this.methodologyType);
		const fileName = `VpcOverview-${name}-${methodologyName}-${versionName}-${this.selectedUnit.displayName}`;
		await this.lessonPlanListService
			.exportVpcOverviewExcel(id, fileName, this.versionId, this.selectedUnit.id)
			.then((data) => {
				BlobHelper.saveFile(data);
				this.setLoading(false);
			});
	}

	@Action
	async getComponentObjectivesPDF({ lessonPlanVersionId, methodology }) {
		this.setLoading(true);
		const { id, name } = this.versionGroup;
		const contentName = this.contents.find((c) => c.id == this.contentId)?.title;
		const methodologyName = MethodologyTypeItems.get(methodology);
		const fileName = `TeachingPlan-${name}-${methodologyName}-${this.selectedUnit.displayName}-${contentName}`;
		const params = {
			versionGroupId: id,
			unitId: this.selectedUnit.id,
			contentId: this.contentId,
			lessonPlanVersionId: lessonPlanVersionId,
			fileName: fileName
		};
		await ContentExposureService.exportComponentObjectivesPDF(params).then((data) => {
			BlobHelper.saveFile(data, `${fileName}.pdf`);
			this.setLoading(false);
		});
	}

	@Action
	async getComponentObjectivesPDFZip({ lessonPlanVersionId, methodology }) {
		this.setLoading(true);
		const { id, name } = this.versionGroup;
		const methodologyName = MethodologyTypeItems.get(methodology);
		const fileName = `TeachingPlan-${name}-${methodologyName}-${this.selectedUnit.displayName}`;
		const params = {
			versionGroupId: id,
			unitId: this.selectedUnit.id,
			lessonPlanVersionId: lessonPlanVersionId,
			methodology,
			fileName: fileName
		};
		await ContentExposureService.exportComponentObjectivesPDFZip(params).then((data) => {
			BlobHelper.saveFile(data);
			this.setLoading(false);
		});
	}

	@Action
	formatContentExposures(contentExposures: any[]) {
		contentExposures.forEach((d) => {
			d.key = d.id;
			d.duration = { start: toTimeString(d.minPlanningTime), end: toTimeString(d.maxPlanningTime) };
			d.relatedItems = d.contentExposureRelatedItem.map((item) => ({
				contentId: item.contentId,
				type: item.type,
				title: item.content?.title || item.text,
				vcsLevelId: item.content?.vcsLevelId,
				unitName: item.content?.vcsLevel?.displayName,
				text: item.text,
				unit: item.content?.vcsLevel?.unit,
				sequence: item.sequence,
				typeSequence: item.typeSequence,
				contentType: item.content?.contentType,
				typeName: item.content?.contentType?.name
			}));
			d.teachingActivities = d.contentExposureTeachingActivity.map((item) => ({
				sequence: item.sequence,
				...item.teachingActivity
			}));
			d.objectives = d.contentExposureObjective.map((item) => ({
				...item.contentObjective,
				...item.contentObjective.objective,
				contentExposureId: item.contentExposureId
			}));
		});
	}
}

export const ReportsModule = getModule(ReportsObjectiveState);
